import Container from "react-bootstrap/Container";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Image } from "react-bootstrap";
import ProgressBar from 'react-bootstrap/ProgressBar';

function Skills () {

    const redirectToWebsite = (url) => {
        window.open(url, '_blank');
      };

    return (

        <section id="skills" className="block skills-block">
            <div className='title-holder'>
                    <h2>Skills and Certifications</h2>
                </div>
            <Container fluid>
            <h3 className="skills-title fw-bold">My Certifications</h3>
            <p></p>
                <Row>
                    <Col xs={6} className="certificate-col">
                        <Image className="certificate1" src={require("../assets/images/certificate1.png")} data-title="Certificate 1" />
                        <h5 id="certificate-name">MS Powerpoint Associate</h5>
                    </Col>
                    <Col xs={6} className="certificate-col">
                        <Image className="certificate2" src={require("../assets/images/certificate2.png")} data-title="Certificate 2" />
                        <h5 id="certificate-name">TOPCIT Level 2</h5>
                    </Col>
                </Row>
            </Container>
            <p></p>
            <Container fluid>
            <h3 className="skills-title fw-bold">My Programming Journey</h3>
            <p></p>
                <Row>
                    <div className="language-title">
                    <h5>Programming Languages</h5>
                    </div>
                    <Col xs={2} className="language-block">
                            <Image src={require("../assets/images/c.png")} className="language-logo"/>
                    </Col>
                    <Col xs={2} className="language-block">
                        <Image src={require("../assets/images/c++.png")} className="language-logo"/>
                    </Col>
                    <Col xs={2} className="language-block">
                        <Image src={require("../assets/images/java.png")} className="language-logo"/>
                    </Col>
                    <Col xs={2}className="language-block">
                        <Image src={require("../assets/images/python.png")} className="language-logo"/>
                    </Col>
                    <Col xs={2}className="language-block">
                        <Image src={require("../assets/images/javascript.png")} className="language-logo"/>
                    </Col>
                    <Col xs={2}className="language-block">
                        <Image src={require("../assets/images/php.png")} className="language-logo"/>
                    </Col>
                </Row>
                <Row>
                    <div className="language-title">
                    <h5>Frameworks</h5>
                    </div>
                    <Col xs={2} className="language-block">
                            <Image src={require("../assets/images/node js.png")} className="language-logo"/>
                    </Col>
                    <Col xs={2} className="language-block">
                        <Image src={require("../assets/images/laravel.png")} className="language-logo"/>
                    </Col>
                    <Col xs={2} className="language-block">
                        <Image src={require("../assets/images/react.png")} className="language-logo"/>
                    </Col>
                    <Col xs={2}className="language-block">
                        <Image src={require("../assets/images/reactbootstrap.jpg")} className="language-logo"/>
                    </Col>
                    <Col xs={2}className="language-block">
                        <Image src={require("../assets/images/react-native.png")} className="language-logo"/>
                    </Col>
                    <Col xs={2}className="language-block">
                        <Image src={require("../assets/images/next.png")} className="language-logo"/>
                    </Col>
                </Row>
            </Container>
            <p></p>
            <Container fluid>
            <h3 className="skills-title fw-bold">My Works</h3>
            <p></p>
                <Row>
                    <Col xs={3}>
                        <Container className="works-container" onClick={() => redirectToWebsite('https://github.com/httperror505/CSFE2-Prelim')}>
                            <Image className="certificate1" src={require("../assets/images/github-logo-vector.png")} data-title="Certificate 1" />
                        </Container>
                        <p></p>
                            <p>Languages:</p>
                            <ProgressBar>
                                <ProgressBar variant="success" now={100} key={1} />
                            </ProgressBar>
                            <div className="p-1">
                                <p className="inline-language" id="javascript">• </p>
                                <p className="inline-language">Javascript - 100%</p>
                            </div>
                    </Col>
                    <Col xs={3}>
                        <Container className="works-container" onClick={() => redirectToWebsite('https://github.com/httperror505/Ncean-Repository')}>
                            <Image className="certificate1" src={require("../assets/images/github-logo-vector.png")} data-title="Certificate 1" />
                        </Container>
                        <p></p>
                            <p>Languages:</p>
                            <ProgressBar>
                                <ProgressBar variant="success" now={100} key={1} />
                            </ProgressBar>
                            <div className="p-1">
                                <p className="inline-language" id="javascript">• </p>
                                <p className="inline-language">Javascript - 100%</p>
                            </div>
                    </Col>
                    <Col xs={3}>
                        <Container className="works-container" onClick={() => redirectToWebsite('https://github.com/httperror505/personal-website')}>
                            <Image className="certificate1" src={require("../assets/images/github-logo-vector.png")} data-title="Certificate 1" />
                        </Container>
                        <p></p>
                            <p>Languages:</p>
                            <ProgressBar>
                                <ProgressBar variant="success" now={50} key={1} />
                                <ProgressBar variant="warning" now={45} key={2} />
                                <ProgressBar variant="info" now={6} key={3} />
                            </ProgressBar>
                                <div className="language">
                                    <p className="inline-language" id="javascript">• </p>
                                    <p className="inline-language">Javascript - 50.7%</p>
                                </div>
                                <div className="language">
                                    <p className="inline-language" id="css">• </p>
                                    <p className="inline-language">CSS - 44.0%</p>
                                </div>
                                <div className="language">
                                    <p className="inline-language" id="html">• </p>
                                    <p className="inline-language">HTML - 5.3%</p>
                                </div>
                    </Col>
                    <Col xs={3}>
                        <Container className="works-container" onClick={() => redirectToWebsite('https://github.com/httperror505/CSELEC1-Project')}>
                            <Image className="certificate1" src={require("../assets/images/github-logo-vector.png")} data-title="Certificate 1" />
                        </Container>
                        <p></p>
                            <p>Languages:</p>
                            <ProgressBar>
                                <ProgressBar variant="danger" now={100} key={1} />
                            </ProgressBar>
                            <div className="p-1">
                                <p className="inline-language" id="cplusplus">• </p>
                                <p className="inline-language">C++ - 100%</p>
                            </div>
                    </Col>
                    
                </Row>
            </Container>
        </section>
    )

}

export default Skills;
